// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationBlockCardPath = 'M89.5 8c5.704 0 10.346 4.548 10.496 10.216l.004.284v47c0 5.704-4.548 10.346-10.216 10.496L89.5 76H79v-7h10.5a3.5 3.5 0 003.495-3.308L93 65.5V41H7v24.5a3.5 3.5 0 003.308 3.495L10.5 69H21v7H10.5C4.796 76 .154 71.452.004 65.784L0 65.5v-47C0 12.796 4.548 8.154 10.216 8.004L10.5 8h79zM7 34h86v-5H7v5zm86-15.5V22H7v-3.5l.005-.192A3.5 3.5 0 0110.5 15h79l.192.005A3.5 3.5 0 0193 18.5zM54 76v7h-8v-7h8zm-6.365-28.826a16.01 16.01 0 0118.36 15.434l.005.398v1h6v17.025a7.333 7.333 0 01-1.466 4.35L65.52 92.09a7.363 7.363 0 01-5.86 2.917H40.394c-2.29.01-4.454-1.048-5.887-2.904l-5.15-6.892A7.381 7.381 0 0128 81.006v-17h6v-.56c-.115-8.03 5.652-14.94 13.635-16.272zM59 63.007v1H41v-.882c.063-4.503 3.305-8.299 7.726-9.037 2.53-.375 5.162.387 7.147 2.098A9.01 9.01 0 0159 63.007zm6 8H35v9.954c0 .06.017.117.068.196l.046.064 4.966 6.645c.068.089.174.14.3.14h19.273a.352.352 0 00.273-.125l5.006-6.697a.33.33 0 00.068-.178v-10z';
var IllustrationBlockCard = baseIllustration('IllustrationBlockCard', {
  getPath: () => IllustrationBlockCardPath
}, 'ColoredIllustrationBlockCard');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationBlockCard;
//# sourceMappingURL=index.js.map